import type { ReactNode } from "react";
import { Link } from "react-router-dom";

interface SectionHeadingProps {
  icon?: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  children?: ReactNode;
}

export default function SectionHeading({
  icon,
  title,
  subtitle,
  moreTo,
  moreLabel = "查看全部",
  children,
}: SectionHeadingProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-extrabold text-foreground-950 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-100 text-primary-600">
              <i className={`${icon} text-lg`}></i>
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-2 text-sm text-foreground-500">{subtitle}</p>}
      </div>
      {children}
      {moreTo && (
        <Link
          to={moreTo}
          className="flex items-center gap-1 whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-semibold text-accent-600 transition-colors hover:bg-accent-100"
        >
          {moreLabel}
          <i className="ri-arrow-right-line"></i>
        </Link>
      )}
    </div>
  );
}